import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import router from './router'
import store from './store/'
// import './registerServiceWorker'
// import '@babel/polyfill'
// import 'babel-polyfill'

// new
// global elements
// import 'bootstrap/dist/css/bootstrap.min.css'

// nuevos
import '@babel/polyfill'
import './pollyfills'
import VueNotify from 'vue-notifyjs'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import FormTitle from '@/components/FormTitle.vue'
import SweetAlert from '@/components/Wrapper/SweetAlert.vue'

// import '@/assets/sass/paper-dashboard.scss'
// import '@/assets/sass/element_variables.scss'
// import '@/assets/sass/demo.scss'
// import '@/assets/inspinia/css/inspinia.css'

import sidebarLinks from './sidebarLinks'

import VueI18n from 'vue-i18n'
import messages from '@/plugins/i18n'
import * as rules from 'vee-validate/dist/rules'
import es from 'vee-validate/dist/locale/es.json'
import en from 'vee-validate/dist/locale/en.json' // objeto con langs

// import NProgress from 'vue-nprogress'
// const options = {
//   latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
//   router: true, // Show progressbar when navigating routes, default: true
//   http: false // Show progressbar when doing Vue.http, default: true
// };
// Vue.use(NProgress, options)
// const nprogress = new NProgress({ parent: '.nprogress-container' })

// initProgress([])
initProgress(router)

const langs = { es, en }

let locale = navigator ? navigator.language : 'en'
const localStorageLocale = localStorage.getItem('virtual-bricks-lang')
if (localStorageLocale && localStorageLocale.length >= 2) locale = localStorageLocale

if (locale.indexOf('-') !== -1) {
  locale = locale.split('-')[0]
}

// only valid locales
if (['en', 'es'].indexOf(locale) === -1) locale = 'en'

// TEMPORAL OVERRIDE
// locale = 'en'
// locale = 'es'
console.log('>>> locale set to:', locale)
localStorage.setItem('virtual-bricks-lang', locale)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
})

if (!langs[locale]) locale = 'en' // fallback locale

// configure({
//   defaultMessage: (field, values) => {
//     // override the field name.
//     values._field_ = i18n.t(`fields.${field}`)
//     return i18n.t(`validation.${values._rule_}`, values)
//   }
// })

// loop over all rules
for (const rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: langs[locale].messages[rule] // add its message
  })
}

Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, { sidebarLinks: sidebarLinks })
Vue.component('FormTitle', FormTitle)
Vue.component('SweetAlert', SweetAlert)

// font awesome 5
library.add(faUserSecret)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  // nprogress,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
